import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { Text } from '@atlaskit/primitives';
import { RequestReadState } from '@atlassian/notification-types/types';
import { ErrorBoundarySuspense } from '../../../../common/ui/error-boundary-suspense';
import { LazyFlag as LazyNoNotificationsSVG } from '../../../../common/ui/flag';
import { triggerViewedAllNotificationsUIEvent, useCreateFireAnalyticsFromTrigger } from '../../../../common/utils/analytics';
import { ExperienceSuccess } from '../../../../common/utils/experience-tracking/adapter/experience-success';
import { Experiences } from '../../../../common/utils/experience-tracking/types';
import messages from '../../../../common/utils/i18n/messages';
import { CenterLayout, NoNotificationsSkeleton, NoNotificationsTextContainer } from './styled';
export var NoMoreNotifications = function NoMoreNotifications(_ref) {
  var readStateFilter = _ref.readStateFilter,
    viewedCount = _ref.viewedCount;
  var fireViewedAllNotifications = useCreateFireAnalyticsFromTrigger(triggerViewedAllNotificationsUIEvent);
  useEffect(function () {
    fireViewedAllNotifications(viewedCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(CenterLayout, {
    "data-testid": "no-more-notifications"
  }, /*#__PURE__*/React.createElement(ExperienceSuccess, {
    name: Experiences.RENDER_NOTIFICATIONS_WITHOUT_CONTENT,
    attributes: {
      noNotificationsScreen: true
    }
  }), /*#__PURE__*/React.createElement(ErrorBoundarySuspense, {
    loadingFallback: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(NoNotificationsSkeleton, null)),
    errorFallback: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(NoNotificationsSkeleton, {
      noAnimation: true
    })),
    subjectId: "noNotifications"
  }, /*#__PURE__*/React.createElement(LazyNoNotificationsSVG, null)), /*#__PURE__*/React.createElement(NoNotificationsTextContainer, null, /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, readStateFilter === RequestReadState.ANY ? /*#__PURE__*/React.createElement(FormattedMessage, messages.noNotificationsLoadingDescription) : /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.noUnreadNotifications, {
    values: {
      strong: function strong(chunks) {
        return /*#__PURE__*/React.createElement(Text, {
          as: "strong"
        }, chunks);
      }
    }
  })))));
};